import React, {Component} from 'react';
import {Spin, Button} from 'antd';
import {getQueryArgs} from './utils/parser/url';
import Config from './config';
import propExists from './utils/objects/props';
import * as User from "./utils/user";
import {refreshToken, getUserTokens, validateToken} from "./containers/user/api";
import AdminLayout from "./AdminLayout";


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuth: false,
            isLoading: true,
            key: getQueryArgs(window.location.href, 'key'),
            user: {},
            isOnline: true,
            isError: false,
        };
        this.tokenInterval = 0;
    }

    // format messages for spinner tip
    getTipMessage = () => {
        if (this.state.isError) {
            // render reload btn
            return (
                <React.Fragment>
                    <div>Error, while loading your authorization</div>
                    <Button onClick={() => {
                        User.clearUserTokens();
                        window.location.href = window.location.pathname
                    }} htmlType={"button"} type={"primary"} icon={"reload"} style={{marginTop: 10}}>Reload page</Button>
                </React.Fragment>
            );
        }
        if (this.state.isOnline === false) return `Check your internet connection`;
        if (this.state.isAuth === false) return `Loading your authorization`;
    };

    // watch token updates
    watchTokenUpdate = () => {
        this.tokenInterval = setInterval(() => {
            let tokens = User.getTokens();
            if (tokens['access']) {
                clearInterval(this.tokenInterval);
                this.validateUserToken();
            }
        }, 400);
    };

    generateUserError = (e) => {
        this.setState({
            isError: true,
        }, () => {
            Error(e, `app`)
        });
    };

    // refresh user token
    refreshToken = () => {
        refreshToken().then(data => {
            if (propExists(data, `data.tokens`)) {
                User.setTokens(data.data.tokens);
                this.validateUserToken();
            } else {
                this.generateUserError({
                    status: 403,
                    statusText: `Error generate tokens for your, click reload btn please`
                });
            }
        }).catch(e => {
            this.generateUserError(e);
        });
    };

    // load user tokens by key
    loadUserTokensByKey = async (key) => {
        try {
            let data = await getUserTokens(key);
            if (propExists(data, `data.tokens`)) {
                User.setTokens(data.data.tokens);
            } else {
                this.generateUserError({
                    status: 403,
                    statusText: `Error generate tokens for your, click reload btn please`
                });
            }
        } catch (e) {
            this.generateUserError(e);
        }
    };


    // validate user tokens
    validateUserToken = () => {
        validateToken().then(data => {
            // check that user info exists and user id exists and not null or empty string
            if (propExists(data, `data.user`) && data.data.user.id) {
                // if key not empty and we validate tokens after authorization
                if (this.state.key !== undefined) {
                    window.close();
                } else {
                    this.setState({
                        user: data.data.user,
                        isAuth: true,
                        isLoading: false,
                    }, () => {
                        window.currentUser = this.state.user;
                    });
                }
            } else {
                this.generateUserError({
                    status: 500,
                    statusText: `Error load your authorization info, click reload button please`
                });
            }
        }).catch(e => {
            if (e.status && e.status === 401) {
                this.refreshToken();
            } else {
                // if all tokens expired
                if (e.answer && e.answer.error === Config.ERRORS.TOKEN_EXPIRED) {
                    User.clearUserTokens();
                    window.location.reload();
                }
                this.generateUserError(e);
            }
        });
    };

    componentDidMount() {
        let tokens = User.getTokens();
        // user open app with key
        if (this.state.key) {
            this.watchTokenUpdate();
            this.loadUserTokensByKey(this.state.key)
        } else {
            // check that access token exists
            if (tokens['access']) {
                this.validateUserToken();
            } else {
                // open oauth page
                window.open(`${Config.OAUTH}?callback=${Config.PROJECT_PATH}&front=1`);
                this.watchTokenUpdate();
            }
        }
    }

    render() {
        return (
            <Spin wrapperClassName={"app-loading"} spinning={this.state.isLoading} tip={this.getTipMessage()}>
                <div className={`app app--container ${Config.PROJECT}`}>
                    {this.state.isAuth && <AdminLayout/>}
                </div>
            </Spin>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js